import { render } from "./PromoToolsContainer.vue?vue&type=template&id=74820360&scoped=true"
import script from "./PromoToolsContainer.vue?vue&type=script&lang=js"
export * from "./PromoToolsContainer.vue?vue&type=script&lang=js"

import "./PromoToolsContainer.vue?vue&type=style&index=0&id=74820360&scoped=true&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74820360"]])

export default __exports__